import { ChangeDetectorRef, Component, ElementRef, Input, OnInit } from '@angular/core';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
declare const $: any;

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.css'],
})
export class AudioPlayerComponent implements OnInit {
  @Input() path: string;
  @Input() isAnsMedia = false;

  audioIsPlaying = false;
  idKey: string;
  currentValue = '00:00';
  isMuted = false;
  circumFurance = 0;
  strokeDashoffset = 0;
  timeline: HTMLElement;
  playhead: HTMLElement;
  timelineWidth = 0;
  isMouseMove = false;
  isMobile = false;
  progress1 = 0;
  isPreview: boolean;
  isButtonDown = false;
  isMobile1 = false;

  constructor(
    private changeDetect: ChangeDetectorRef,
    private service: ParticipationDataService,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    this.idKey = Math.random().toString(36).replace(/[^a-z]+/g, '').substring(2, 10);
    if(this.idKey == '')
    {
      this.idKey = Math.random().toString(36).replace(/[^a-z]+/g, '').substring(2, 10);
    }
    this.isMobile1 = this.service.getMobile();
    this.isPreview = this.service.GroupType.toUpperCase() === 'PREVIEW';
    const body = document.body;
    this.isMobile = body.classList.contains('mobile-scroll');
  }

  ngAfterViewInit() {
    if (!this.isAnsMedia || this.isMobile1) {
      setTimeout(() => {
        this.updateCurrentTimeAndTotalDuration();
      }, 200);

      if (this.isMobile1 && this.isAnsMedia) {
        const audioWrapper = this.elementRef.nativeElement.querySelector(`#${this.idKey}_audio_wrapper`);
        if (audioWrapper) {
          audioWrapper.closest('.answer-opt-image').classList.add('bg-hide');
        }
      }

      const player = this.elementRef.nativeElement.querySelector(`#${this.idKey}_audio`) as HTMLAudioElement;
      player.addEventListener('loadedmetadata', () => {
        this.updateCurrentTimeAndTotalDuration();
      });
    }
  }

  playAndPauseAudio() {
    const player = this.elementRef.nativeElement.querySelector(`#${this.idKey}_audio`) as HTMLAudioElement;

    if (player.paused) {
      player.play();
      this.audioIsPlaying = true;
      this.checkPlayerStatus(player);
    } else {
      player.pause();
      this.audioIsPlaying = false;
    }
  }

  checkPlayerStatus(player: HTMLAudioElement) {
    if (this.audioIsPlaying) {
      const remainingTime = player.duration - player.currentTime;
      this.setProgress((remainingTime / player.duration) * 100);

      if (remainingTime <= 0) {
        this.audioIsPlaying = false;
        player.pause();
      }

      setTimeout(() => {
        this.checkPlayerStatus(player);
        this.currentTime();
      }, 33);
    }
  }

  setProgress(percent: number) {
    this.progress1 = percent;
    const player = this.elementRef.nativeElement.querySelector(`#${this.idKey}_progress`) as SVGCircleElement;
    const radius = parseFloat(player?.getAttribute('r'));
    if (!isNaN(radius)) {
      const circumference = radius * 2 * Math.PI;
      this.circumFurance = circumference;
      this.strokeDashoffset = circumference - (percent / 100) * circumference;
      this.changeDetect.detectChanges();
    } else {
      console.error('Error: SVG element does not have a valid radius attribute.');
    }
  }

  muteAndUnmute(): void {
    const player = this.elementRef.nativeElement.querySelector(`#${this.idKey}_audio`) as HTMLAudioElement;
    player.muted = !player.muted;
    this.isMuted = player.muted;
  }

  muteAndUnmuteText(): string {
    const player = this.elementRef.nativeElement.querySelector(`#${this.idKey}_audio`) as HTMLAudioElement;
    return player.muted ? 'Unmute' : 'Mute';
  }

  updateCurrentTimeAndTotalDuration(): void {
    const player = this.elementRef.nativeElement.querySelector(`#${this.idKey}_audio`) as HTMLAudioElement;
    const duration = player.duration;

    this.currentValue = this.formatTime(duration);
    this.changeDetect.detectChanges();
  }

  formatTime(value: number): string {
    if (typeof value !== 'number' || isNaN(value)) {
      return '00:00';
    }

    const minutes = Math.floor(value / 60);
    const seconds = Math.floor(value % 60);
    const secondsStr = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${minutes}:${secondsStr}`;
  }

  currentTime(): void {
    const player = this.elementRef.nativeElement.querySelector(`#${this.idKey}_audio`) as HTMLAudioElement;
    const remainingTime = player.duration - player.currentTime;

    if (typeof remainingTime !== 'number' || isNaN(remainingTime)) {
      this.currentValue = '00:00';
    } else {
      const minutes = Math.floor(remainingTime / 60);
      const seconds = Math.floor(remainingTime % 60);
      const secondsStr = seconds < 10 ? `0${seconds}` : `${seconds}`;
      this.currentValue = `${minutes}:${secondsStr}`;
    }

    this.changeDetect.detectChanges();
  }

  audioPlay() {
    const player = this.elementRef.nativeElement.querySelector(`#${this.idKey}_audio`) as HTMLAudioElement;

    if (player.paused) {
      player.play();
      this.audioIsPlaying = true;
      this.checkPlayerStatus1(player);
    } else {
      player.pause();
      this.audioIsPlaying = false;
    }
  }

  checkPlayerStatus1(player: HTMLAudioElement) {
    if (this.audioIsPlaying) {
      const remainingTime = player.duration - player.currentTime;
      this.timeCal(player);

      if (remainingTime <= 0) {
        this.audioIsPlaying = false;
        player.pause();
      }

      setTimeout(() => {
        this.checkPlayerStatus1(player);
        this.currentTime();
      }, 33);
    }
  }

  timeCal(player: HTMLAudioElement) {
    const elem = document.getElementById(this.idKey + '_timeline1');
    const width = elem ? elem.offsetWidth : 0;
    this.currentTime();
    const progressbar = document.getElementById(this.idKey + '_seekObj1');
    if (width * (player.currentTime / player.duration) > width - 7) {
      progressbar.style.marginLeft = width - 7 + 'px';
    } else {
      if (width * (player.currentTime / player.duration) <= 0) {
        progressbar.style.marginLeft = 0 + 'px';
      } else {
        progressbar.style.marginLeft = width * (player.currentTime / player.duration) + 'px';
      }
    }

    const progressbarfill = document.getElementById(this.idKey + '_audiofill');
    if (width * (player.currentTime / player.duration) > width) {
      progressbarfill.style.width = width + 'px';
    } else {
      progressbarfill.style.width = width * (player.currentTime / player.duration) + 'px';
    }
  }

  calculateTotalValue(length: number): string {
    const minutes = Math.floor(length / 60);
    let seconds_int = length - minutes * 60;
    if (seconds_int < 10) {
      seconds_int = 0 + seconds_int;
    }
    const seconds_str = seconds_int.toString();
    const seconds = seconds_str.substring(0, 2);
    const time = minutes + ':' + seconds;
    return time;
  }

  calculateCurrentValue(currentTime: number): string {
    return (
      Math.floor(currentTime / 60) + ':' + (currentTime % 60 !== 0 ? (currentTime % 60).toFixed(0) : '00')
    );
  }

  seek(event, isMouseMove: boolean = true) {
   const player = document.getElementById(this.idKey + '_audio')[0] as HTMLAudioElement;; 
    this.timeline = document.getElementById(this.idKey + '_timeline1');
    this.playhead = document.getElementById(this.idKey + '_seekObj1');
    this.timelineWidth = this.timeline.offsetWidth - this.playhead.offsetWidth;
    player.currentTime =
      player?.duration * this.clickPercent(event, this.timeline, this.timelineWidth);
    this.drag(event);

    if (isMouseMove) {
      this.isMouseMove = true;
    } else {
      this.isMouseMove = false;
    }
  }

  clickPercent(e, timeline, timelineWidth) {
    if (this.isMobile) {
      return (
        ((e.targetTouches[0]
          ? e.targetTouches[0].pageX
          : e.changedTouches[e.changedTouches.length - 1].clientX) -
          this.getPosition(timeline)) /
        timelineWidth
      );
    } else {
      return (e.clientX - this.getPosition(timeline)) / timelineWidth;
    }
  }

  getPosition(el) {
    return el.getBoundingClientRect().left;
  }

  mousedownin() {
    this.isButtonDown = true;
  }

  drag(e) {
    const player = this.elementRef.nativeElement.querySelector(`#${this.idKey}_audio`) as HTMLAudioElement;

    if (this.isMobile) {
      this.timeline = document.getElementById(this.idKey + '_timeline1');
      this.playhead = document.getElementById(this.idKey + '_seekObj1');
      this.timelineWidth = this.timeline.offsetWidth - this.playhead.offsetWidth;
    }

    this.dragFunc(e);
    this.timeCal(player);
  }

  dragFunc(e) {
    this.timeline = document.getElementById(this.idKey + '_timeline1');
    let newMargLeft: number;
    
    if (this.isMobile) {
      newMargLeft =
        (e.targetTouches[0]
          ? e.targetTouches[0].pageX
          : e.changedTouches[e.changedTouches.length - 1].pageX) - this.getPosition(this.timeline);
    } else {
      newMargLeft = e.clientX - this.getPosition(this.timeline);
    }
    if (newMargLeft >= 0 && newMargLeft <= this.timelineWidth) {
      this.playhead.style.marginLeft = newMargLeft - 1 + 'px';
      this.playhead.style.marginLeft = `${newMargLeft - 1}px`;
    }

    if (newMargLeft < 0) {
      this.playhead.style.marginLeft = '0px';
      this.playhead.style.marginLeft = '0px';
    }

    if (newMargLeft > this.timelineWidth) {
      this.playhead.style.marginLeft = this.timelineWidth - 1 + 'px';
      this.playhead.style.marginLeft = `${this.timelineWidth - 1}px`;
    }
  }

  mousemove(e) {
    this.timeline = document.getElementById(this.idKey + '_timeline1');
    this.playhead = document.getElementById(this.idKey + '_seekObj1');
    this.timelineWidth = this.timeline.offsetWidth - this.playhead.offsetWidth;
    if (this.isButtonDown && this.timeline && this.timelineWidth) {
      const player = document.getElementById(this.idKey + '_audio') as HTMLAudioElement;
      this.isMouseMove = false;
      player.currentTime =
        player.duration * this.clickPercent(e, this.timeline, this.timelineWidth);
      this.timeCal(player);
    }
  }

  mouseUpin() {
    this.isButtonDown = false;
  }

  mouseUp(e) {
    const player = this.elementRef.nativeElement.querySelector(`#${this.idKey}_audio`) as HTMLAudioElement;

    this.isMouseMove = false;
    player.currentTime = player.duration * this.clickPercent(e, this.timeline, this.timelineWidth);

    this.timeCal(player);
  }

  totalTime(): string {
    const player = this.elementRef.nativeElement.querySelector(`#${this.idKey}_audio`) as HTMLAudioElement;

    if (player && !isNaN(player.duration)) {
      const value = player.duration;
      return `${Math.floor(value / 60)}:${(value % 60).toFixed(0).padStart(2, '0')}`;
    }

    return '00:00';
  }

  timeUpdate(player: HTMLAudioElement) {
    const player2 = document.getElementById(this.idKey + '_seekObj1');
    const playPercent = this.timelineWidth * (player.currentTime / player.duration);
    player2.style.marginLeft = playPercent - 1 + 'px';
    if (player.currentTime == player.duration) {
      player.pause();
    }
  }
}
